
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10536_2785)","stroke":"#9DA7B2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.45 10.429v1.12a.989.989 0 01-.988.99H3.539a.989.989 0 01-.99-.99v-1.12M4.527 7.033L7 9.505l2.472-2.472M7 9.571V1.857"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10536_2785"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(90 7 7)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    